export default __webpack_public_path__ + "static/media/coming-soon.5bea15ee.png";